/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Asset } from './asset';
import { Pair } from './pair';

/**
 * External trade dto
 */
export interface ExternalTradeDto {
  id: number;
  aggressorSide: ExternalTradeDto.AggressorSideEnum;
  pair: Pair;
  qty: number;
  price: number;
  volume: number;
  ourTrade: boolean;
  maker: boolean;
  platformFee: number;
  platformFeeAsset: Asset;
  tradeLinePlatformTime?: string;
  tradeLineFixSentTime?: string;
  tradeLineReceivedTime?: string;
  mdLinePlatformTime?: string;
  mdLineFixSentTime?: string;
  mdLineReceivedTime: string;
}
export namespace ExternalTradeDto {
  export const AggressorSideEnum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type AggressorSideEnum = (typeof AggressorSideEnum)[keyof typeof AggressorSideEnum];
}
